import EmptyRouterView from '../router/EmptyRouterView';
import AdminBaseDashboard from '../views/AdminBase/AdminBaseDashboard';
import AdminBasePipelines from '../views/AdminBase/AdminBasePipelines';
import AdminBaseCandidates from '../views/AdminBase/AdminBaseCandidates';
import CandidateItem from '../components/Admin/Candidates/CandidateItem';
import AdminBaseJobs from '../views/AdminBase/AdminBaseJobs';
import AdminBaseEmployers from '../views/AdminBase/AdminBaseEmployers';
import AdminBaseReviewJobs from '../views/AdminBase/AdminBaseReviewJobs';
import AdminBaseReviewFreelancers from '../views/AdminBase/AdminBaseReviewFreelancers';
import AdminBaseReviewApplications from '../views/AdminBase/AdminBaseReviewApplications';
import AdminBaseReviewTests from '../views/AdminBase/AdminBaseReviewTests.vue';
import EmployersItem from '../components/Admin/Employers/EmployersItem';
import UserManagment from '../components/Admin/UserManagment/UserManagment';
import AdminBaseLogs from '../views/AdminBase/AdminBaseLogs';
import AdminBaseCompetences from '../views/AdminBase/AdminBaseCompetences';
import AdminBaseSources from '../views/AdminBase/AdminBaseSources';
import AdminBaseZones from '../views/AdminBase/AdminBaseZones';
import AdminBaseCampains from '../views/AdminBase/AdminBaseCampains';
import AdminBasePricePlans from '../views/AdminBase/AdminBasePricePlans.vue';
import AdminBaseWebsite from '../views/AdminBase/AdminBaseWebsite.vue';
import JobItem from '@/components/Admin/Jobs/JobItem';
import AdminBaseSettings from '../views/AdminBase/AdminBaseSettings.vue';
import TestView from '@/components/Admin/TestView';
import AdminBaseAiModels from '../views/AdminBase/AdminBaseAiModels.vue';
import AdminMarketingEmployers from '../views/AdminBase/AdminMarketingEmployers.vue';
import AdminMarketingJobs from '../views/AdminBase/AdminMarketingJobs.vue';
import EmployerMarketingItem from '../components/Admin/Marketing/EmployerMarketingItem.vue';
import JobMarketingItem from '../components/Admin/Marketing/JobItem.vue';
import AdminMarketingContacts from '../views/AdminBase/AdminMarketingContacts.vue';
import EngagementBase from '../views/AdminBase/EngagementBase.vue';

// const url_prefix = process.env.VUE_APP_URL_PREFIX;

export default [
  {
    path: '/admin',
    name: 'admin',
    redirect: '/admin/dashboard',
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
    },
  },
  {
    path: '/admin/dashboard',
    name: 'admin-dashboard',
    component: AdminBaseDashboard,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: 'Dashboard',
    },
  },
  {
    path: '/admin/pipelines',
    name: 'admin-pipelines',
    component: AdminBasePipelines,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        //const { name } = this.$route;
        return 'Pipelines';
      },
    },
  },
  // Admin/Candidates
  {
    path: '/admin',
    component: EmptyRouterView,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
    },
    children: [
      {
        path: '/admin/candidates',
        name: 'admin-candidates',
        component: AdminBaseCandidates,
        meta: {
          requiresAuth: true,
          adminAuth: true,
          recruiterAuth: true,
          breadcrumb: 'Candidates',
        },
      },
      {
        path: '/admin/candidates',
        name: '',
        component: EmptyRouterView,
        meta: {
          breadcrumb: '',
        },
        children: [
          {
            path: '/admin/candidates/:candidate_id',
            name: 'candidate_id',
            component: CandidateItem,
            meta: {
              requiresAuth: true,
              adminAuth: true,
              recruiterAuth: true,
              breadcrumb: function() {
                return `${this.$store.getters.getCandidateById.first_name} ${this.$store.getters.getCandidateById.last_name}`;
              },
            },
          },
        ],
      },
    ],
  },
  // Admin/Jobs
  {
    path: '/admin',
    component: EmptyRouterView,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      managerAuth: true,
    },
    children: [
      {
        path: '/admin/jobs',
        name: 'admin-jobs',
        component: AdminBaseJobs,

        meta: {
          requiresAuth: true,
          adminAuth: true,
          recruiterAuth: true,
          managerAuth: true,
          breadcrumb: 'Jobs',
        },
      },
      {
        path: '/admin/jobs',
        name: '',
        component: EmptyRouterView,
        meta: {
          requiresAuth: true,
          adminAuth: true,
          recruiterAuth: true,
          managerAuth: true,
          breadcrumb: '',
        },
        children: [
          {
            path: '/admin/jobs/:job_uuid',
            name: 'job_uuid',
            component: JobItem,
            meta: {
              requiresAuth: true,
              adminAuth: true,
              recruiterAuth: true,
              managerAuth: true,
              breadcrumb: function() {
                return '';
              },
            },
          },
        ],
      },
    ],
  },
  // Admin/Employers
  {
    path: '/admin',
    component: EmptyRouterView,
    meta: {
      /* requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true, */
    },
    children: [
      {
        path: '/admin/employers',
        name: 'admin-employers',
        component: AdminBaseEmployers,
        meta: {
          requiresAuth: true,
          adminAuth: true,
          recruiterAuth: true,
          managerAuth: true,
          breadcrumb: 'Employers',
        },
      },
      {
        path: '/admin/employers',
        name: '',
        component: EmptyRouterView,
        meta: {
          requiresAuth: true,
          adminAuth: true,
          recruiterAuth: true,
          managerAuth: true,
          breadcrumb: '',
        },
        children: [
          {
            path: '/admin/employers/:employer_id',
            name: 'employer_id',
            component: EmployersItem,
            meta: {
              requiresAuth: true,
              adminAuth: true,
              recruiterAuth: true,
              managerAuth: true,
              breadcrumb: function() {
                return this.$store.getters.getEmployerById.name;
              },
            },
          },
        ],
      },
    ],
  },
  {
    path: '/admin/user-managment',
    name: 'user-managment',
    component: UserManagment,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
    },
  },
  {
    path: '/admin/settings',
    name: 'admin-settings',
    component: AdminBaseSettings,
    meta: { adminAuth: false, requiresAuth: true, recruiterAuth: true },
  },
  // Admin Review
  {
    path: '/admin/review/jobs',
    name: 'admin-review-jobs',
    component: AdminBaseReviewJobs,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        return 'Review / Jobs';
      },
    },
  },
  {
    path: '/admin/review/applications',
    name: 'admin-review-applications',
    component: AdminBaseReviewApplications,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        return 'Review / Applications';
      },
    },
  },
  {
    path: '/admin/review/freelancers',
    name: 'admin-review-freelancers',
    component: AdminBaseReviewFreelancers,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        return 'Review / Freelancers';
      },
    },
  },
  {
    path: '/admin/review/tests',
    name: 'admin-review-tests',
    component: AdminBaseReviewTests,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        return 'Review / Freelancers';
      },
    },
  },
  /* Marketing Pages */
  {
    path: '/admin/marketing/employers',
    name: 'admin-marketing-employers',
    component: AdminMarketingEmployers,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: () => 'marketing / employers',
    },
  },
  {
    path: '/admin/marketing/employers/:employer_id',
    name: 'employer_marketing_id',
    component: EmployerMarketingItem,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      managerAuth: true,
    },
  },
  {
    path: '/admin/marketing/jobs',
    name: 'admin-marketing-jobs',
    component: AdminMarketingJobs,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        return 'marketing / employers';
      },
    },
  },
  {
    path: '/admin/marketing/jobs/:job_id',
    name: 'job_marketing_id',
    component: JobMarketingItem,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      managerAuth: true,
    },
  },
  {
    path: '/admin/marketing/contacts',
    name: 'admin-marketing-contacts',
    component: AdminMarketingContacts,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        return 'marketing / employers';
      },
    },
  },
  {
    path: '/admin/logs',
    name: 'logs',
    component: AdminBaseLogs,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        return 'Logs';
      },
    },
  },
  {
    path: '/admin/competences',
    name: 'competences',
    component: AdminBaseCompetences,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        return 'Competences';
      },
    },
  },
  {
    path: '/admin/sources',
    name: 'sources',
    component: AdminBaseSources,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        return 'Sources';
      },
    },
  },
  {
    path: '/admin/zones',
    name: 'zones',
    component: AdminBaseZones,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        return 'Zones';
      },
    },
  },
  {
    path: '/admin/campaigns',
    name: 'campaigns',
    component: AdminBaseCampains,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        return 'Campaigns';
      },
    },
  },
  {
    path: '/admin/pricing',
    name: 'price-plans',
    component: AdminBasePricePlans,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        return 'Campaigns';
      },
    },
  },
  {
    path: '/admin/website',
    name: 'website',
    component: AdminBaseWebsite,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        return 'Campaigns';
      },
    },
  },
  {
    path: '/admin/aimodels',
    name: 'aimodels',
    component: AdminBaseAiModels,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        return 'AI models';
      },
    },
  },
  {
    path: '/admin/engagement',
    name: 'engagement',
    component: EngagementBase,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      breadcrumb: function() {
        return 'AI models';
      },
    },
  },
  /* TEST VIEW */
  {
    path: '/admin/test',
    name: 'test',
    component: TestView,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      recruiterAuth: true,
      /* breadcrumb: function() {
        return 'Review / Applications';
      }, */
    },
  },

  /* Mobile */
  {
    path: '/admin/candidates/add-candidate',
    name: 'add-candidate-mobile',
    component: () => import('../components/Admin/Candidates/AddCandidateBtnModalMobile'),
    meta: {
      requiresAuth: true,
      adminAuth: true,
      breadcrumb: () => {
        return 'Add Candidate';
      },
    },
  },
  {
    path: '/admin/jobs/add-job',
    name: 'add-job-mobile',
    component: () => import('../components/Admin/Jobs/AddJobBtnModalMobile'),
    meta: {
      requiresAuth: true,
      adminAuth: true,
      breadcrumb: () => {
        return 'Add Job';
      },
    },
  },
  {
    path: '/add-employer',
    name: 'add-employer-mobile',
    component: () => import('../components/Admin/Employers/AddEmployerBtnModalMobile'),
    meta: {
      requiresAuth: true,
      adminAuth: true,
    },
  },
];
